<template src="./index.html" />
<script>
import { mapState } from 'vuex';
import TableProject from './tableProject/index.vue';
export default {
  name: 'Users',
  components: {
    TableProject,
  },
  data: () => ({
    headers: [
      {
        text: 'Name', align: 'left', sortable: true, value: 'name', width: 200,
      }, {
        text: 'Company', align: 'left', sortable: false, value: 'company', width: 200,
      }, {
        text: 'Account Status', align: 'left', sortable: true, value: 'accountConfirmed', width: 50,
      }, {
        text: '', align: 'right', sortable: false, value: 'action', width: 50,
      },
    ],
  }),
  computed: {
    ...mapState(['users']),
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
